(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["3dboxlab-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    document.querySelectorAll('.bl-mobile-nav[open]').forEach((menu) => {
      if (!menu.contains(event.target) || event.target.closest('.bl-nav-close, nav a')) {
        menu.open = false;
        if (event.target.closest('.bl-nav-close')) menu.querySelector('summary').focus();
      }
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.bl-mobile-nav[open]').forEach((menu) => {menu.open=false;menu.querySelector('summary').focus();});
  });
  } catch(e) { console.error(e); }
})();

})();
